import AboutCards from "./AboutCards";
import AboutStepper from "./AboutStepper";

function AboutSwitcher(props) {
  const viewVariant = props.viewVariant;
  const AboutView = viewVariant === "stepper" ? AboutStepper : AboutCards;

  return <AboutView {...props} />;
}

export default AboutSwitcher;
